__turbopack_context__.v({
  "card": "_3EM5YW_card",
  "cardContent": "_3EM5YW_cardContent",
  "cardHeader": "_3EM5YW_cardHeader",
  "chevron": "_3EM5YW_chevron",
  "hero-reveal": "_3EM5YW_hero-reveal",
  "services": "_3EM5YW_services",
  "subtitle": "_3EM5YW_subtitle",
  "title": "_3EM5YW_title",
  "what-we-do": "_3EM5YW_what-we-do",
});
